"use client";

import { SwiperSlide } from "swiper/react";
import type SwiperCore from "swiper";
import { FC } from "react";
import styles from "apps/website/components/feature/Carousel/Carousel.module.css";
import cx from "apps/website/utils/misc/cx";
import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";

import Carousel from "../Carousel";
import {
  IRecipeCard,
  RecipeCard,
} from "../../RecipeList/RecipeCard/RecipeCard";

export interface IRecipesCarouselProps {
  recipes: IRecipeCard[];
  styleOptions?: {
    slideBgColor?: Theme;
    carouselBgColor?: Theme;
    hasShadow?: boolean;
  };
  onSwiperInit?: (swiper: SwiperCore) => void;
}

export const RecipesCarousel: FC<IRecipesCarouselProps> = ({ recipes, styleOptions, onSwiperInit }) => {

  const { slideBgColor = "light-grey", carouselBgColor = "light-grey", hasShadow = false } = styleOptions || {};
  return (
    <Carousel
      component={RecipesCarousel.name}
      breakpoints={{ default: 1.2, md: 2.2 }}
      wrapperClassName={cx(styles.equalHeightSlides, themeRootClassMap[carouselBgColor])}
      navigationStyle="default"
      spaceBetween="lg"
      onInitSwiper={onSwiperInit}
    >
      { recipes.map((recipe) => (
        <SwiperSlide key={recipe.titleTag.label} className={ cx(themeRootClassMap[slideBgColor]) }>
          <RecipeCard
            {...recipe}
            styleOptions={{ imageBgColor: "light", imageScale: 110, hasShadow }}
          />
        </SwiperSlide>
      )) }
    </Carousel>
  );
};
